var _desc, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "17px",
    viewBox: "0 0 13 17",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.23779C0 2.67722 2.98801 -0.203435 6.60225 0.0112726C9.80497 0.172303 12.3994 2.85615 12.4888 6.07676C12.5246 7.27554 12.2204 8.40276 11.6658 9.35105L6.99588 16.5974C6.65593 17.1342 5.85078 17.1342 5.51082 16.5974L0.840938 9.35105C0.304169 8.43854 0 7.365 0 6.23779ZM3.18483 6.2199C3.18483 7.91966 4.56253 9.27948 6.24441 9.27948C7.92628 9.27948 9.30399 7.91966 9.30399 6.2199C9.30399 4.53802 7.92628 3.16032 6.24441 3.16032C4.54464 3.16032 3.18483 4.53802 3.18483 6.2199Z",
    id: "Shape-Copy-3",
    fill: "#005DA4",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.feac3d3aa132d032584f53a69ed75f1e.svg";
export { ForwardRef as ReactComponent };